import { FC } from "react"

const PasswordView: FC = () => <></>

export { PasswordView }
